import { render, staticRenderFns } from "./FamilyUserInfo.vue?vue&type=template&id=1afdfc3f&scoped=true&"
import script from "./FamilyUserInfo.vue?vue&type=script&lang=js&"
export * from "./FamilyUserInfo.vue?vue&type=script&lang=js&"
import style0 from "./FamilyUserInfo.vue?vue&type=style&index=0&id=1afdfc3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afdfc3f",
  null
  
)

export default component.exports